import { connect } from 'react-redux'
import React, { Component } from 'react'
import { history } from '../helper/history'
import localdata from '../helper/localdata'
import util from '../helper/util'

class Page404 extends Component {
    constructor(props) {
        super(props)

        localdata.get_login_result().then((payload) => {
            util.log("get_login_result: ", payload)
            let to_login = true

            if (payload.status == "OK") {
                if (payload.results) {
                    if (payload.results.session_id) {
                        let type = payload.results.user_type
                        if (type === 'MASTER_AGENT') {
                            setTimeout(() => {
                                history.replace('/master')
                            }, 500);
                            to_login = false;
                        }
                    }
                }
            }

            if (to_login) {
                setTimeout(() => {
                    history.replace('/login')
                }, 500);
            }

        }).catch((err) => {
            setTimeout(() => {
                history.replace('/login')
            }, 500);
        })
    }

    render() {
        return (
            <div className="m-grid m-grid--hor m-grid--root m-page">
                
            </div >
        )
    }
}

const mapStateToProps = (state) => ({
    session : state.Session
})

export default connect(mapStateToProps, null)(Page404)


// WEBPACK FOOTER //
// ./src/page/page_404.js